export default "__VITE_ASSET__DxvDWOXO__"